<template>
    <div v-if="buildYourJewelMode">
        <Breadcrumb></Breadcrumb>
        <div class="stepper-container">
            <div class="step-div" :class="{ 'active': step.active, 'expanded': step.expanded }"
                v-for="(step, index) in steps" v-on:mouseover="step.expanded = true"
                v-on:mouseleave="step.expanded = false">
                <div class="step" @click="setActiveStep(step.id)"
                    :class="{ 'disabled': index != 0 && !isCompleted(steps[index - 1]), 'step-arrow': (index < steps.length - 1) }">
                    <span class="step-index">{{ index + 1 }}</span>
                    <span class="step-name">{{ $t('build_your_jewel.' + step.id) }}</span>
                    <div class="selected-stones" v-if="!isCompleted(step) && stonesNumber > 1 && step.id == 'STONE'">{{
        selectedStones.length +
        '/' + stonesNumber }}</div>
                    <span class="step-status">
                        <div v-if="isCompleted(step)"><font-awesome-icon class="info-button cursor-pointer"
                                :icon="['fas', 'check-circle']" /></div>
                    </span>
                </div>
                <div class="step-detail-container" v-if="step.expanded && isCompleted(step) && !step.active">
                    <div class="step-detail" :class="{ 'd-block': step.id == 'STONE' }" v-if="step.id == 'STONE'">
                        <div v-for="selectedStone of selectedStones" class="d-flex">
                            <div>
                                <div class="step-object-title">{{ selectedStone.cartItem.name }}</div>
                                <p class="step-object-description">{{ selectedStone.cartItem.billingDescription }}</p>
                            </div>
                            <!--<div class="step-object-price">{{ $t("from") + ' ' + formatPrice(selectedStone.buildYourJewelPrice * retailPerc) }}
                            </div>-->
                        </div>
                    </div>

                    <div class="step-detail" v-if="step.id == 'SETTING'">
                        <div>
                            <div class="step-object-title">
                                <img width="30%" :src="baseImageUrl + selectedSetting.image" />
                                {{ selectedSetting.name }}
                            </div>
                            <!--<p class="step-object-description">{{ jewelDescription }}</p>-->
                        </div>
                        <div class="step-object-weight">{{ $t("from") + ' ' + formatWeight(selectedSetting.minGoldWeight) }}</div>
                    </div>

                    <div class="change-btn"><button class="btn secondary-btn w-100" @click="setActiveStep(step.id)">{{
        $t("build_your_jewel.edit") }}</button></div>
                </div>
            </div>

        </div>
        <div class="step-navigator-btn-div">
            <div>
                <button class="btn" v-if="!isFirstStep" @click="previousStep && setActiveStep(previousStep.id)"
                    :disabled="!previousStep"><font-awesome-icon class="mr-1" :icon="['fa', 'angle-left']" />{{
        $t('previous_step') }}</button>
            </div>
            <div>
                <button v-if="!isLastStep" class="btn" @click="nextStep && setActiveStep(nextStep.id)"
                    :disabled="!nextStep || !isCompleted(activeStep)">{{ $t('next_step') }}<font-awesome-icon
                        class="ml-1" :icon="['fa', 'angle-right']" /></button>
            </div>
        </div>
        <StoneList v-if="activeStep.id == 'STONE'" :buildYourJewelMode="buildYourJewelMode"></StoneList>
        <SubListSection v-if="activeStep.id == 'SETTING'"></SubListSection>
        <Detail v-if="activeStep.id == 'CUSTOMIZE'" stones="selectedStones" setting="selectedSetting"></Detail>
    </div>
</template>

<script>
import StoneList from './StoneList.vue';
import SubListSection from './SubListSection.vue';
import Detail from './Detail.vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import Vue from "vue";
import Breadcrumb from './Breadcrumb.vue';

export default {
    components: { StoneList, SubListSection, Detail, Breadcrumb },
    name: "BuildYourJewel",
    data: function () {
        return {
            baseImageUrl: process.env.VUE_APP_IMAGE_PATH,
        }
    },
    computed: {
        ...mapState({
            buildYourJewelMode: (state) => state.buildYourJewel.buildYourJewelMode,
            steps: (state) => {
                let steps = [];
                if (state.buildYourJewel.buildYourJewelMode == 'STONE')
                    steps = state.buildYourJewel.stepsFromStone
                else if (state.buildYourJewel.buildYourJewelMode == 'SETTING')
                    steps = state.buildYourJewel.stepsFromSetting
                return steps;
            },
            selectedStones: (state) => state.buildYourJewel.selectedStones,
            selectedSetting: (state) => state.buildYourJewel.selectedSetting,
            stonesNumber: (state) => state.buildYourJewel.stonesNumber,
            jewelDescription: (state) => state.detail.jewelDescription,
            retailPerc: (state) => state.detail.retailPerc,
        }),
        activeStep: function () {
            return this.steps.find(s => s.active)
        },
        previousStep: function () {
            return this.steps[this.steps.findIndex(s => s.active) - 1]
        },
        nextStep: function () {
            return this.steps[this.steps.findIndex(s => s.active) + 1]
        },
        isFirstStep: function () {
            return this.steps.findIndex(s => s.active) == 0;
        },
        isLastStep: function () {
            return this.steps.findIndex(s => s.active) == this.steps.length - 1;
        },
    },
    methods: {
        ...mapMutations("buildYourJewel", [
            "setBuildYourJewelMode",
            "setStonesNumber",
        ]),
        ...mapActions("buildYourJewel", [
            "setActiveStep",
            "resetBuildYourJewel"
        ]),
        isCompleted(step) {
            return (step.id == 'STONE' && this.selectedStones.length == this.stonesNumber) || (step.id == 'SETTING' && this.selectedSetting);
        },
        addToBasket() {
            this.$parent.addToBasket();
        },
        formatPrice: function (price) {
            return Vue.formatPrice(price) + "€";
        },
        formatWeight: function (weight) {
            return weight + " g";
        }
    },
    created() {
        this.setBuildYourJewelMode(this.$route.params.startFrom);
        this.setStonesNumber(this.$route.params.stonesNumber);
    },
    destroyed() {
        this.resetBuildYourJewel(false);
    }
}

</script>

<style lang="scss" scoped>
.stepper-container {
    margin: 20px;
    display: flex;
    height: 60px;

    .step-div {
        width: 100%;
        border: 2px solid var(--primary-color-1);
        border-left: 0;
        border-right: 0;

        &:first-of-type {
            border-left: 2px solid var(--primary-color-1);

            &.active {
                border: 2px solid var(--primary-color-1);
            }
        }

        &:nth-of-type(2) {
            .step-detail-container {
                margin: 0px;
                margin-right: -2px;
            }
        }

        &:last-of-type {
            border-right: 2px solid var(--primary-color-1);
        }

        &.active {
            background-color: var(--primary-color-1);
            color: white;

            .step:before {
                border-right: 25px solid var(--primary-color-1);
            }

            .step-index {
                border: 2px solid white;
            }
        }

        &.expanded:not(.active) {
            .step {
                background-color: #eee;
                color: var(--primary-color-1);

                &.step-arrow:before {
                    border-right: 25px solid #eee;
                }
            }

            .step-detail-container {
                background-color: #eee;
            }

        }

    }

    .step {
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
        justify-content: center;
        position: relative;

        &:not(.disabled) {
            cursor: pointer;
        }

        &.step-arrow:before {
            content: "";
            position: absolute;
            top: 50%;
            right: -24px;
            transform: translateY(-50%) rotate(180deg);
            border-top: 29px solid transparent;
            /* Adjust the size of the arrow */
            border-bottom: 29px solid transparent;
            /* Adjust the size of the arrow */
            border-right: 25px solid white;
            z-index: 2;
            /* Arrow color */
        }

        &.step-arrow:after {
            content: "";
            position: absolute;
            top: 50%;
            right: -25px;
            transform: translateY(-50%) rotate(180deg);
            border-top: 30px solid transparent;
            /* Adjust the size of the arrow */
            border-bottom: 30px solid transparent;
            /* Adjust the size of the arrow */
            border-right: 25px solid var(--primary-color-1);
            /* Arrow color */
            z-index: 1;
        }

        &.disabled {
            opacity: 0.5;
            pointer-events: none;
        }

        .step-index {
            padding: 2px;
            background-color: var(--primary-color-1);
            border: 2px solid white;
            color: white;
            border-radius: 100%;
            width: 32px;
            height: 32px;
            left: 30px;
            font-weight: bold;
        }

        .step-name {
            margin-left: 10px;
            cursor: pointer;
        }

        .step-status {
            margin-left: 20px;
            font-size: 24px;
            color: green;
        }

    }


    .step-detail-container {
        border: 2px solid var(--primary-color-1);
        z-index: 10000;
        position: relative;
        background-color: white;
        padding: 20px;
        margin-left: -2px;
        margin-right: -2px;
        border-top: 0;
    }

    .step-detail {
        display: flex;
        justify-content: space-between;
    }

    .step-object-title,
    .step-object-price {
        font-weight: bold;
        padding: 10px;
        text-transform: uppercase;
        text-align: left;
    }

    .step-object-weight {
        font-weight: bold;
        padding: 10px;
        text-align: left;
    }

    .step-object-title {
        align-items: flex-start;
        display: flex;
        gap: 10px;
    }

    .step-object-price,
    .step-object-weight {
        white-space: nowrap;
    }

    .step-object-description {
        text-align: left;
        padding: 10px;
    }

    .change-btn {
        padding: 10px;
        width: 100%;
        cursor: pointer;
    }
}

@media only screen and (max-width: 768px) {

    .stepper-container {

        margin: 0;
        margin-top: 10px;

        .step {
            .step-name {

                font-size: 14px;
                margin-left: 30px;
            }

            .step-index {
                display: none;
            }
        }

        .step-detail-container {
            display: none;
        }
    }
}

.selected-stones {
    padding: 2px;
    background-color: #ddd;
    border: 2px solid white;
    color: var(--primary-color-1);
    border-radius: 100%;
    width: 32px;
    height: 32px;
    margin-left: 10px;
}

.step-navigator-btn-div {
    display: flex;
    justify-content: space-between;
    margin: 20px;
}
</style>